// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router/index'
import store from './store'
import api from './api'
import config from './config'

Vue.use(BootstrapVue)

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  console.log(store.state.token)
  console.log(window.localStorage.token)
  console.log(to.path)
  if (to.path !== '/login' && !window.localStorage.token) {
    window.console.log('Not authenticated')
    next('/login')
  } else if (to.path === '/login' && window.localStorage.token) {
    next('/')
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  },
  data: function () {
    return {
      renewTokenInterval: null
    }
  },
  beforeMount () {
    if (window.localStorage.token) {
      if (this.hasTokenExpired()) {
        window.localStorage.clear()
        router.push('/login')
      }
    }
  },
  mounted () {
    this.renewToken()
    this.renewTokenInterval = setInterval(() => {
      this.renewToken()
    }, 60 * 60 * 1000)
  },
  methods: {
    hasTokenExpired: function () {
      let token = window.localStorage.token
      if (!token) return true
      try {
        let exp = JSON.parse(atob(token.split('.')[1])).exp
        let now = Date.now()
        return (exp > now)
      } catch (err) {
        return true
      }
    },
    renewToken () {
      if (!this.hasTokenExpired()) {
        api.request('get', config.serverURI + 'tokens/renew', null, {
          token: btoa(Math.floor(new Date() / 1000))
        })
          .then(response => {
            // store.commit('SET_TOKEN', response.data)
            window.localStorage.setItem('token', response.data)
            // router.push('/')
          })
          .catch(error => {
            if (error.response !== undefined) {
              window.localStorage.clear()
              router.push('/login')
            }
          }) 
      } else {
        window.localStorage.clear()
        router.push('/login')
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.renewTokenInterval)
  }
})
